export enum PropertyRegime {
  COMUNHAO_PARCIAL = 'COMUNHAO_PARCIAL',
  REGIME_LEGAL_BENS = 'REGIME_LEGAL_BENS',
  COMUNHAO_UNIVERSAL = 'COMUNHAO_UNIVERSAL',
  SEPARACAO_TOTAL_BENS = 'SEPARACAO_TOTAL_BENS',
  PARTICIPACAO_FINAL_AQUESTOS = 'PARTICIPACAO_FINAL_AQUESTOS'
}
